export const MONTHS_IT = [
  "", "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre",
];

export const SEASON_MONTHS = [6, 7, 8, 9, 10]; // Estate 2026
export const SEASON_YEAR = 2026;

export function monthStr(year, month) {
  return `${year}-${String(month).padStart(2, "0")}`;
}

export function daysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

export function firstWeekday(year, month) {
  // Monday=0 .. Sunday=6
  const d = new Date(year, month - 1, 1).getDay();
  return (d + 6) % 7;
}

export const WEEKDAYS_IT = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
